'use es6';

export const SLUG_EXISTS = 'SLUG_EXISTS';
export const PAGE_EXISTS = 'PAGE_EXISTS';
export const TEMPLATE_COPY_MODAL = 'TEMPLATE_COPY_MODAL';
export const PAGES_USING_TEMPLATE_MODAL = 'PAGES_USING_TEMPLATE_MODAL';
export const CANT_EDIT_LAYOUT_MODAL = 'CANT_EDIT_LAYOUT_MODAL';